const VIA_CHANNEL_STORAGE_KEY = 'lb-channels-via';

type ViaChannel = 'imessage' | 'whatsapp';

// pure, so it is safe to call during render
export const readViaChannel = (): ViaChannel | undefined => {
  const via =
    new URLSearchParams(window.location.search).get('via') ??
    sessionStorage.getItem(VIA_CHANNEL_STORAGE_KEY);
  return via === 'imessage' || via === 'whatsapp' ? via : undefined;
};

export const readCheckoutReturnChannel = () =>
  window.location.pathname.startsWith('/channels')
    ? readViaChannel()
    : undefined;

// in-app navigation drops the search; keep the agent link's ?via= for the session
export const rememberViaChannel = () => {
  const via = readViaChannel();
  if (via) sessionStorage.setItem(VIA_CHANNEL_STORAGE_KEY, via);
};
